<template>
  <div class="coupon-card" :style="{backgroundImage:'url('+bgImg+')'}">
    <div class="card-content">
      <div class="card-content-number">
        <div class="number-row">
          <div class="number-pointer"
            :class="{'greyNum': couponInfo.lotteryStatus === 10}"
            :style="{'backgroundColor': numberBg}"
            v-for="(item,index) in couponCode"
            :key="index">{{ item }}</div>
        </div>
        <div class="number-time">有效期：{{ couponInfo.startDate | parseTime('{y}-{m}-{d}') }}至{{ couponInfo.endDate | parseTime('{y}-{m}-{d}') }}</div>
      </div>
      <div class="card-content-msg" v-if="couponStatus">
        <div class="msg-large">{{ couponMsg }}</div>
        <div class="msg-middle">{{ couponNumber }}积分</div>
      </div>
      <div class="card-content-msg msg-fail" v-else>
        <div class="msg-large">{{ couponMsg }}</div>
        <div class="msg-middle msg-border" v-if="!couponInfo.lotteryStatus">距离开奖还有{{ fromDay }}天</div>
        <div class="msg-middle" v-else>多扫多得</div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
export default {
  name: 'LotteryCouponCard',
  props: {
    couponInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      bgImg: '',
      couponStatus: Boolean,
      couponMsg: '',
      couponNumber: '',
      numberBg: ''
    }
  },
  computed: {
    couponCode () {
      return commonUtils.formatToArr(this.couponInfo.lotteryCode)
    },
    fromDay () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      return new Date(year, month, 0).getDate() - day + 1
    }
  },
  created () {
    this.setCouponInfo()
    this.getBg()
  },
  methods: {

    setCouponInfo () {
      switch (this.couponInfo.lotteryStatus) {
        case 0:
          this.couponStatus = false
          this.couponMsg = '等待开奖'
          break
        case 10:
          this.couponStatus = false
          this.couponMsg = '未中奖'
          break
        case 50:
          this.couponStatus = true
          this.couponMsg = '参与奖'
          this.couponNumber = '5000'
          break
        case 60:
          this.couponStatus = true
          this.couponMsg = '三等奖'
          this.couponNumber = '2万'
          break
        case 70:
          this.couponStatus = true
          this.couponMsg = '二等奖'
          this.couponNumber = '10万'
          break
        case 80:
          this.couponStatus = true
          this.couponMsg = '一等奖'
          this.couponNumber = '100万'
          break
        default:
          break
      }
    },

    getBg () {
      if (this.couponInfo.lotteryStatus === 0) {
        this.bgImg = require('../../../assets/images/lottery/jq_1.png')
        this.numberBg = '#2c535d'
      } else if (this.couponInfo.lotteryStatus === 10) {
        this.bgImg = require('../../../assets/images/lottery/jq_3.png')
      } else {
        this.bgImg = require('../../../assets/images/lottery/jq_2.png')
        this.numberBg = '#074fa3'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.coupon-card {
  width: 345px;
  height: 80px;
  margin: 15px auto 0 auto;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .card-content {
    display: flex;
    height: 80px;
    width: 100%;
    .card-content-number {
      height: 100%;
      width: 232px;
      padding: 0 20px 0 15px;
      box-sizing: border-box;
      .number-row {
        display: flex;
        margin-top: 30px;
        justify-content: space-between;
        .number-pointer {
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          border-radius: 20px;
          // background-color: rgb(8,78,163);
          color: #fff;
          font-size: 10px;
        }
        .greyNum {
          border: 1px solid #989898;
          color: #989898;
        }
      }
      .number-time {
        font-size: 11px;
        color: #999;
        margin-top: 5px;
      }
    }
    .card-content-msg {
      height: 100%;
      width: 113px;
      color: #fff;
      text-align: center;
      padding: 35px 15px 0px 0px;
      box-sizing: border-box;
      .msg-large {
        font-size: 18px;
        font-weight: bold;
      }
      .msg-middle {
        font-size: 12px;
        margin-top: 4px;
        padding: 3px 0px;
      }
      .msg-border {
        border: 1px solid #ffffff;
        border-radius: 5px;
      }
    }
    .msg-fail {
      padding-top: 20px;
    }
  }
}
</style>
